import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';

import {
  Field,
  LENGTH_LEI,
  LENGTH_GIIN,
} from '../../../forms/identificationNumbersForm';

export const FormContent = () => {
  const { t } = useTranslation();

  return (
    <Stack spacing={24} spacingMobile={16}>
      <Field.Text
        showOptionalMark
        label={t('onboarding.identificationNumbers.LEI.label')}
        maxLength={LENGTH_LEI}
        name="LEI"
        placeholder={t('onboarding.identificationNumbers.LEI.placeholder')}
      />
      <Field.Text
        showOptionalMark
        label={t('onboarding.identificationNumbers.GIIN.label')}
        maxLength={LENGTH_GIIN}
        name="GIIN"
        placeholder={t('onboarding.identificationNumbers.GIIN.placeholder')}
      />
    </Stack>
  );
};
